"use strict";

var BasicBookletWeddingPrograms = require('./BasicBookletWeddingPrograms');

var DeluxeBookletWeddingPrograms = require('./DeluxeBookletWeddingPrograms');

var FlatBookletWeddingPrograms = require('./FlatBookletWeddingPrograms');

var SquareWeddingPrograms = require('./SquareWeddingPrograms');

module.exports = {
  BasicBookletWeddingPrograms: BasicBookletWeddingPrograms,
  DeluxeBookletWeddingPrograms: DeluxeBookletWeddingPrograms,
  FlatBookletWeddingPrograms: FlatBookletWeddingPrograms,
  SquareWeddingPrograms: SquareWeddingPrograms,
  BasicBookletWeddingProgramReprints: BasicBookletWeddingPrograms,
  DeluxeBookletWeddingProgramReprints: DeluxeBookletWeddingPrograms,
  FlatBookletWeddingProgramReprints: FlatBookletWeddingPrograms,
  SquareWeddingProgramReprints: SquareWeddingPrograms
};